<script setup lang="ts">
import { mdiMenuRight } from '@mdi/js'
import SvgIcon from '../icon/SvgIcon.vue'

interface Props {
  icon: string
  text: string
  active?: boolean
  expand?: boolean
  disabled?: boolean
}

defineProps<Props>()
</script>

<template>
  <button
    type="button"
    class="relative flex items-center justify-between transition-[width,opacity] linear duration-200 rounded-tl-lg rounded-br-lg w-full px-3 py-2 not-disabled:cursor-pointer"
    :class="
      active
        ? 'inset-shadow-sm inset-shadow-black/70 bg-gray-800'
        : !disabled && 'bg-black hover:bg-gray-800'
    "
    :disabled="disabled"
    v-bind="$attrs"
  >
    <div class="flex items-center">
      <SvgIcon
        :path="icon"
        class="w-6 h-6 shrink-0"
        :class="disabled ? 'fill-gray-500' : 'fill-white'"
      />
      <div
        class="text-md text-white whitespace-nowrap"
        :class="expand ? 'opacity-100' : 'opacity-0 w-0 overflow-hidden'"
      >
        <span class="m-8">{{ text }}</span>
      </div>
    </div>
    <SvgIcon
      :path="mdiMenuRight"
      class="fill-white shrink-0"
      :class="expand ? 'opacity-100 w-6 h-6' : 'opacity-0 w-0 overflow-hidden'"
    />
  </button>
</template>
